var initSelectInput = function () {
    var elems = document.querySelectorAll("select");
    M.FormSelect.init(elems, {});
};

document.addEventListener("DOMContentLoaded", initSelectInput);
